import React, { createContext, useContext, useState, useCallback } from 'react';
import translations from '../config/translations';

const LanguageContext = createContext();

const LS_KEY = 'app_language';

export const LanguageProvider = ({ children }) => {
    const [language, setLanguageState] = useState(() => {
        try {
            return localStorage.getItem(LS_KEY) || 'zh';
        } catch {
            return 'zh';
        }
    });

    const setLanguage = useCallback((lang) => {
        setLanguageState(lang);
        try { localStorage.setItem(LS_KEY, lang); } catch {}
    }, []);

    const t = useCallback((key) => {
        const parts = key.split('.');
        let obj = translations;
        for (const p of parts) {
            obj = obj?.[p];
            if (!obj) return key;
        }
        return obj[language] || obj['en'] || key;
    }, [language]);

    return (
        <LanguageContext.Provider value={{ language, setLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const ctx = useContext(LanguageContext);
    if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
    return ctx;
};

export default LanguageContext;
